import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useProductPrice } from '~/scopes/product-core/composables/useFetch/useFetchProductPrice/composables/useProductPrice/useProductPrice'
import { useFetchServicePickers } from '~/scopes/product-core/composables/useFetch/useFetchServicePickers/useFetchServicePickers'

export function useFetchProductPrice() {
  const { selectedOffer } = useFetchPickers()
  const { data: servicesPickersResponse } = useFetchServicePickers()

  return useProductPrice({
    pickers: servicesPickersResponse,
    selectedOffer,
  })
}
